import { useMutation } from '@apollo/client';

import { CreateTicketTransactionInput } from '../../apollo/__generated__/graphql';
import { CREATE_TICKET_TRANSACTION } from '../graphql/mutations/createTicketTransactionMutation.graphql';

export const useCreateTicketTransactionMutation = () => {
  const [mutate] = useMutation(CREATE_TICKET_TRANSACTION, {
    onCompleted: (data) => {
      window.location.href = data.createTicketTransaction;
    },
  });

  const createTicketTransaction = (
    createTicketTransactionInput: CreateTicketTransactionInput,
  ) =>
    mutate({
      variables: {
        createTicketTransactionInput,
      },
    });

  return { createTicketTransaction };
};
